import { Body, Box, Heading } from '@hover/blueprint';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useFormattedTimeAgo } from 'src/modules/homeownerApp/hooks';
import { useGetProjectShareQuery } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const DetailsHeading = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { id } = useParams<{ id: string }>();

  const { data } = useGetProjectShareQuery({
    variables: { id },
  });
  const { createdAt } = data?.projectShare || {};

  const dateCreated = useFormattedTimeAgo(createdAt, false);

  return (
    <Box flexDirection="column">
      <Heading noMargin size={{ base: 600, tablet: 800 }}>
        {t('share.yourHomeInspiration')}
      </Heading>
      {dateCreated && (
        <Body
          color="neutral.secondaryText"
          fontWeight={400}
          m={0}
          mt={200}
          opacity={0.64}
          size={200}
        >
          {`${t('share.shared')} ${dateCreated?.toLowerCase()}`}
        </Body>
      )}
    </Box>
  );
};
